export const FIXED_DATE_TYPE = 0;

export const DATE_TYPE_LABELS: Record<number, string> = {
  0: "Fixed date",
  1: "Tax year end",
  2: "Incorporation month",
  3: "Foreign qual month",
  4: "Tax year start",
  5: "Biennial even year",
  6: "Biennial odd year",
  7: "Biennial even year (FQ)",
  8: "Biennial odd year (FQ)",
};

export const DATE_TYPE_DESCRIPTIONS: Record<number, string> = {
  0: "A specific calendar day and month, e.g. January 15.",
  1: "Deadline is relative to the last day of the entity's tax year.",
  2: "Deadline is relative to the month the entity was incorporated.",
  3: "Deadline is relative to the month the entity qualified to do business in this state.",
  4: "Deadline is relative to the first day of the entity's tax year.",
  5: "Filing is due every two years, in even-numbered years.",
  6: "Filing is due every two years, in odd-numbered years.",
  7: "Biennial even-year filing based on foreign qualification month.",
  8: "Biennial odd-year filing based on foreign qualification month.",
};

export const DEADLINE_DAY_SUFFIX: Record<number, string> = {
  1: "1st",
  2: "15th",
  3: "last day",
};

export const MONTH_SHORT_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const monthLabel = (m: number) => MONTH_SHORT_NAMES[(m - 1) % 12];

export const DEADLINE_DAY_OPTIONS = [
  { label: "None", value: "0" },
  { label: "1st of month", value: "1" },
  { label: "15th of month", value: "2" },
  { label: "Last day of month", value: "3" },
];

export const FIRST_DEADLINE_LOGIC_OPTIONS = [
  { label: "None", value: "0" },
  { label: "Within 90 days of registration", value: "1" },
];

export const TAXED_AS_OPTIONS = [
  { label: "None", value: "0" },
  { label: "Corporation", value: "1" },
  { label: "Partnership", value: "2" },
  { label: "Single member LLC", value: "3" },
];
